const t = {
  name: "Save",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 22C3.34772 22 2 20.6523 2 19V5C2 3.34772 3.34772 2 5 2H17.4142L22 6.58579V19C22 20.6523 20.6523 22 19 22H5ZM5 4C4.45228 4 4 4.45228 4 5V19C4 19.5477 4.45228 20 5 20H6V11H18V20H19C19.5477 20 20 19.5477 20 19V7.41421L16.5858 4H15V9H6V4H5ZM16 20V13H8V20H16ZM8 4V7H13V4H8Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Save
};
